import {
  Avatar,
  Button,
  Card,
  CardHeader,
  Fab,
  Grid,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import Hidden from "@material-ui/core/Hidden";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Add, MoreVert } from "@material-ui/icons";
import Skeleton from "@material-ui/lab/Skeleton";
import React from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import { confirm } from "../../components/ConfirmationDialog/ConfirmationDialog";
import InputSearch from "../../components/InputSearch/InputSearch";
import { AntTab, AntTabs } from "../../components/TabPanel/TabPanel";
import { default as roleStore } from "../../Store/RoleStore";
import { submitForm } from "./Container/Form";
import "./Role.css";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      width: "100%",
    },
    button: {
      margin: 0,
      maxHeight: 30,
      padding: 1,
    },
    paper: {
      padding: 8,
      width: 290,
    },
    demo1: {
      backgroundColor: theme.palette.background.paper,
      marginBottom: 10,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(14),
      color: "#FFFFFF",
      textAlign: "center",
      backgroundColor: "#BEBEBE",
      borderRadius: "4px",
    },
    control: {
      padding: theme.spacing(2),
    },
    room: {
      fontSize: "18px",
      fontWeight: 600,
    },
    fab: {
      position: "fixed",
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    card: {
      margin: 5,
      width: "300px",
    },
  })
);

function RoleList(props) {
  const { data, permissionEditRole, permissionDeleteRole } = props;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Card className={classes.card}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe">
            {`${data.name ? data.name.trim().split(" ")[0].charAt(0) : "S"}`}
          </Avatar>
        }
        action={
          <React.Fragment>
            <IconButton aria-label="settings" onClick={handleClick}>
              <MoreVert />
            </IconButton>
            <Menu
              id="long-menu"
              elevation={0}
              anchorEl={anchorEl}
              getContentAnchorEl={null}
              keepMounted
              open={open}
              onClose={handleClose}
            >
              {permissionEditRole && (
                <MenuItem onClick={() => props.doEdit(data)}>Edit</MenuItem>
              )}

              {/* {permissionDeleteRole &&
                <MenuItem onClick={() => props.doDelete(data)}>Delete</MenuItem>
              } */}
            </Menu>
          </React.Fragment>
        }
        title={data.name}
      />
    </Card>
  );
}

function Role(props) {
  const classes = useStyles();
  const [componentWillmount, setComponentWillMount] = React.useState(false);
  const [search, setSearch] = React.useState("");
  const [inputSearch, setInputSearch] = React.useState("");
  const [tab] = React.useState(0);
  const [roleState, roleActions] = roleStore();
  let perPage = 10;

  React.useEffect(() => {
    var query = {
      num: perPage.toString(),
      cursor: "",
      position: "",
      search: search,
    };

    const timer = setTimeout(() => {
      roleActions.getModulelist(query);
      roleActions.get(query);
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  const handleActions = (value) => {
    if (value) {
      submitForm("Update Role", value).then(
        (onProcess) => {},
        (onCancel) => {
          setComponentWillMount(!componentWillmount);
        }
      );
    } else {
      submitForm("Create Role", null).then(
        (onProcess) => {},
        (onCancel) => {
          setComponentWillMount(!componentWillmount);
        }
      );
    }
  };

  const handleGetUserList = () => {
    var query = {
      num: perPage.toString(),
      cursor: roleState.header["x-cursor"],
      position: "",
      search: "",
    };
    roleActions.getList(query);
  };

  const handleDelete = (value) => {
    confirm("Delete", "Are you sure to Delete ?").then(async (onProcess) => {
      await roleActions.deleted(value);
      setComponentWillMount(!componentWillmount);
    });
  };

  const handleSearch = (e) => {
    setInputSearch(e.target.value);
    setSearch(e.target.value);
  };

  return (
    <BaseLayout>
      <Grid container className={classes.root}>
        <Grid container style={{ padding: 5, marginBottom: 10 }}>
          <Grid
            container
            item
            xs={10}
            direction="row"
            alignItems="flex-end"
            justify="flex-start"
          >
            <InputSearch
              value={inputSearch}
              onChange={(e) => {
                handleSearch(e);
              }}
              placeholder="Search Role"
            />
          </Grid>
          <Grid container item xs={2} justify="flex-end" alignItems="flex-end">
            <Hidden xsDown implementation="css">
              {props.params.create && (
                <Tooltip
                  title="add role"
                  aria-label="add"
                  arrow
                  placement="bottom"
                >
                  <Fab
                    onClick={() => handleActions(null)}
                    color="secondary"
                    variant="extended"
                    aria-label="add"
                    style={{ marginRight: "10px" }}
                  >
                    <Add /> Add{" "}
                  </Fab>
                </Tooltip>
              )}
            </Hidden>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <div className={classes.demo1}>
            <Grid container>
              <Grid
                container
                item
                xs
                direction="row"
                alignItems="flex-end"
                justify="flex-start"
              >
                <AntTabs
                  style={{ marginTop: "10px" }}
                  value={tab}
                  aria-label="ant example"
                >
                  <AntTab label="Role List" />
                </AntTabs>
              </Grid>
            </Grid>
          </div>

          <Grid item xs={12} container justify="center">
            {(roleState.isLoading
              ? Array.from(new Array(10))
              : roleState.data
            ).map((value, key) => {
              return (
                <React.Fragment key={key}>
                  {value ? (
                    <RoleList
                      data={value}
                      permissionEditRole={props.params.update}
                      doEdit={() => handleActions(value)}
                      permissionDeleteRole={props.params.delete}
                      doDelete={() => handleDelete(value)}
                    />
                  ) : (
                    <Card className={classes.card}>
                      <CardHeader
                        avatar={
                          <Skeleton
                            variant="circle"
                            width="40px"
                            height="40px"
                          />
                        }
                        action={
                          <IconButton aria-label="settings">
                            <MoreVert />
                          </IconButton>
                        }
                        title={<Skeleton width="20%" height="10px" />}
                        subheader={<Skeleton width="5%" height="10px" />}
                      />
                    </Card>
                  )}
                </React.Fragment>
              );
            })}
          </Grid>
          {!roleState.isLoading && roleState.data.length === 0 && (
            <Grid item xs={12}>
              <div className={classes.demo1}>
                <Grid
                  item
                  xs
                  container
                  justify="center"
                  style={{ margin: 10, padding: 12 }}
                >
                  <span>No Data</span>
                </Grid>
              </div>
            </Grid>
          )}
          {roleState.data.length >= perPage - 1 && (
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              style={{ padding: "10px" }}
            >
              {roleState.lastPage || !roleState.header.cursor ? (
                <h2>~</h2>
              ) : (
                <Button
                  onClick={() => handleGetUserList()}
                  size="small"
                  color="secondary"
                  variant="contained"
                  disabled={roleState.isLoading}
                >
                  {roleState.isLoading ? "Please Wait" : "Load More"}
                </Button>
              )}
            </Grid>
          )}
          <Hidden smUp implementation="css">
            {props.params.create && (
              <Tooltip title="add role" aria-label="add" arrow placement="left">
                <Fab
                  aria-label="Add"
                  classes={{ root: "FabMobile" }}
                  className={classes.fab}
                  color="primary"
                  onClick={() => handleActions(null)}
                >
                  <Add />
                </Fab>
              </Tooltip>
            )}
          </Hidden>
        </Grid>
      </Grid>
    </BaseLayout>
  );
}

export default Role;
